import React, { useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { updateBoard } from "../../../../../services/apiBoards";
import { schema } from "../../../../../schemas/updateKeyBoard";
import { RFHTextField } from "../../../../../components/RFH";
import { CustomButton } from "../../../../../components/Button/Button";
import useMutate from "../../../../../hooks/useMutate";

function KeyForm({ params, onClose }) {

  const queryClient = useQueryClient();

    // Memoize default values
    const defaultValues = useMemo(() => ({
      board_name: params.row.board_name,
      key: params.row.key,
    }), [params.row.board_name, params.row.key]);

  // React Hook Form
  const { handleSubmit, ...methods } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { mutate, isPending: loading } = useMutate(updateBoard,["boards"], () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["boardName", `${params.row.board_id}`],
      });
      //toast.success(res.data.message);
      onClose();
    }
  );

  const submit = useCallback((data) => {
    /**
     * Update Board
     */
    mutate({ data, board_id: params.row.board_id });
  }, [mutate, params.row.board_id]);

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        sx={{
          padding: "14px",
        }}
        className="rename-board-form"
      >
        <Stack spacing={3}>

          <RFHTextField name={"board_name"}
            label={"Board Name"}
            disabled
            className="rename-board-form-field"
          />

          <RFHTextField name={"key"}
            label={"Key"}
            required
            className="rename-board-form-field"
          />

          <Box className="admin-board-button-container d-flex">
            <CustomButton
              type="submit"
              variant="contained"
              className="admin-board-update-button"
              disabled={loading}>
              Update
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="admin-board-cancel-button"
              onClick={onClose}
              disabled={loading}>
              Cancel
            </CustomButton>
          </Box>
        </Stack>
      </Box>
    </FormProvider>
  );
}

const isChangeKeyForm = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.key === nextProps?.params?.row?.key
  );
};

export default React.memo(KeyForm,isChangeKeyForm);
